import { Box, Button, IconButton, Stack, Typography } from "@mui/material"
import { styles } from "./styles/PayLicenseAlert.styles"
import { useLicenceContext } from "contexts/LicenceContext"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import { useAuthContext } from "contexts/AuthContext"

const smashyImg = require("assets/img/auth/smashy-01.gif")
const smashorImg = require("assets/img/auth/smasher-01.gif")

export default function PayLicenseAlert({ onClose }) {
  const { t } = useTranslation()
  const { accountType } = useAuthContext()
  const { onTeacherMessage, isB2C, openMembershipsPage } = useLicenceContext()

  return (
    <Box sx={[styles.alert]}>
      <Stack alignItems={"center"} p={1} position={"relative"}>
        <IconButton sx={styles.closeButton} onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <Stack direction={"row"} sx={styles.content}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={styles.lottieContainer}
          >
            <Box
              component="img"
              src={accountType < 7 ? smashyImg : smashorImg}
              alt="Smashy Character"
              sx={styles.smashyCharacter}
            />
          </Stack>
          <Typography variant="span" sx={styles.message} fontSize={14}>
            {t(
              isB2C
                ? "student_alert_membership_required"
                : "school_alert_student_license"
            )}
          </Typography>
        </Stack>
        <Button
          variant="contained"
          disableElevation
          sx={styles.button}
          onClick={isB2C ? openMembershipsPage : onTeacherMessage}
        >
          {t(isB2C ? "see_memberships" : "contact_your_teacher")}
        </Button>
      </Stack>
    </Box>
  )
}
